import { Vestiging } from "@/entities/vestiging";
import { ColumnDef, FlexRender, useTable } from "@tanstack/react-table";
import type { FaciliteitenTableFeatures } from "./faciliteiten-table-features";
import { faciliteitenTableFeatures } from "./faciliteiten-table-features";

interface BaseFaciliteitenTableProps {
    stationCode: string;
    vestigingen: Vestiging[];
    columns: ColumnDef<FaciliteitenTableFeatures, Vestiging>[];
    columnWidths?: readonly string[];
}

export function BaseFaciliteitenTable({ stationCode, vestigingen, columns, columnWidths }: Readonly<BaseFaciliteitenTableProps>) {
    const table = useTable({
        data: vestigingen,
        columns,
        features: faciliteitenTableFeatures,
    });

    return (
        <table className="w-full table-fixed" data-testid={`faciliteiten-table-${stationCode}`}>
            {columnWidths && (
                <colgroup>
                    {columnWidths.map((width, index) => (
                        <col key={index} style={{ width }} />
                    ))}
                </colgroup>
            )}
            <tbody>
                {table.getRowModel().rows.map((row) => (
                    <tr key={row.id} data-testid={`vestiging-${Vestiging.getDisplayName(row.original)}`}>
                        {row.getAllCells().map((cell) => (
                            <td className="py-2" key={cell.id}>
                                <FlexRender cell={cell} />
                            </td>
                        ))}
                    </tr>
                ))}
            </tbody>
        </table>
    );
}
